import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import React from 'react';
import Currencies  from './components/Currencies'

function App() {
  return (
    <Currencies />
  );
}

export default App;
